import LocalStorageService from './local-storage.service';

/**
 * Stores URL parameters in browser storage.
 */
class ParameterTracker {

  /**
   * Instantiates the single instance.
   *
   * @returns {ParameterTracker}
   */
  constructor() {
    if (!ParameterTracker._instance) {
      ParameterTracker._instance = this;
    }

    this.storeUrlParameters();

    return ParameterTracker._instance;
  }

  /**
   * Captures the current URL parameters and saves them to browser storage.
   */
  storeUrlParameters() {
    const urlParams = new URLSearchParams(window.location.search);

    this.setParamaterValues(urlParams);
  }

  /**
   * Saves the passed in URLSearchParams to both session and local browser storage.
   *
   * @param {URLSearchParams} urlParams
   */
  setParamaterValues(urlParams) {
    // Next, get any URL parameters from longer term storage.
    let longTermPaidCampaignParams = LocalStorageService.getItem('url_params');

    if (longTermPaidCampaignParams === null) {
      longTermPaidCampaignParams = [];
    }

    // Loop through the long term parameter values.
    // If they already exist in the url parameters, skip them. The URL parameter
    // values should take precedence.
    for (const longTermParam of longTermPaidCampaignParams) {
      if (!urlParams.has(longTermParam[0])) {
        urlParams.set(longTermParam[0], longTermParam[1]);
      }
    }

    // Loop through the parameter entries, and store each in session storage.
    for (const entry of urlParams.entries()) {
      sessionStorage.setItem(entry[0], entry[1]);
    }

    const paramData = [];
    for (const entry of urlParams.entries()) {
      paramData.push([ entry[0], entry[1] ]);
    }

    LocalStorageService.setItem('url_params', paramData);
  }

  /**
   * Returns the given parameter value from session storage.
   *
   * @param param
   *
   * @returns {string}
   */
  getParameterValue(param) {
    return sessionStorage.getItem(param);
  }

}

const instance = new ParameterTracker();

export default instance;